
import { toast } from "react-toastify"
import { fetchConToken, fetchConTokenFileExcel } from "../helpers/fetch"

export const Pptos = {

    getExportNegocios: async (filters) => {
        try {

            const newFilters = {
                ...filters,
                pagination: false
            }

            const params = (new URLSearchParams(newFilters)).toString()

            const fileName = `negocios_${new Date()}_`
            // const resp = await fetchConTokenFileExcel(`budgets/business/export/excel/?${params}`, {}, 'GET', fileName)
            await fetchConTokenFileExcel(`budgets/business/export/excel/?${params}`, {}, 'GET', fileName)
            // const body = await resp.json()

            // if (body.ok) {
            //     return body.data || null

            // } else {

            //     toast.error('Lo sentimos, ocurrió un error')
            //     return null

            // }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getExportCliente: async (paramsIn) => {
        try {

            const params = (new URLSearchParams(paramsIn)).toString()
            const fileName = `pptos_${paramsIn.numero}_${new Date()}_`
            const resp = await fetchConTokenFileExcel(`budgets/export/excel-cliente/?${params}`, {}, 'GET', fileName)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {

                toast.error('Lo sentimos, ocurrió un error')
                return null

            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getTemplates: async () => {
        try {

            // const resp = await fetchConToken('budgets/templates/all')
            const resp = await fetchConToken('templates')
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    getDataTemplate: async (templatesId) => {
        try {

            // const resp = await fetchConToken(`budgets/${budgetId}`)
            const resp = await fetchConToken(`templates/${templatesId}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    getMotivosAnulacion: async () => {
        try {

            const resp = await fetchConToken('general/motivos')
            const body = await resp.json()

            if (body.ok) {
                return body.data || []

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    }


}